import { createDayGridScenario, highlightDayGridItem } from '../actions/dayGridActions';
import getStore from '../store';
import { mutator } from 'satcheljs';
import getScenarioStore from '../selectors/getScenarioStore';

mutator(createDayGridScenario, ({ scenario }) => {
    let scenarios = getStore().scenarios;
    scenarios.set(scenario, { schedulingGridViewState: null });
});

mutator(highlightDayGridItem, ({ scenario, id }) => {
    let store = getScenarioStore(scenario);
    store.highlightedId = id;
});
